const REFUSAL_CODE_PATTERN = /^[a-z][a-z0-9_]{0,63}$/

/** Typed refusal `code` from Nest/python on a failed chart-segment view request. */
export function readChartSegmentRefusalCode(error: unknown): string | null {
  const code = (error as { response?: { data?: { code?: unknown } } } | null)?.response?.data?.code
  if (typeof code !== 'string' || !REFUSAL_CODE_PATTERN.test(code)) {
    return null
  }
  return code
}
